import { useEffect, useState } from 'react';

import ComponentModal from '../../reusable/component-modal/component-modal.component';
import InventoriesTable from '../../reusable/tables/inventory-table/inventory-table.component';
import InventoryDisplay from '../display/inventory-display.component';
import InventoryRestock from '../restock/inventory-restock.component';
import UpdateInventory from '../update/update-inventory.component';
import Spinner from '../../reusable/spinner/spinner.component';

import Client from '../../../tools/client';
import { ensureSocketConnected, onSafe } from '../../../tools/socket';

import {
    ContentContainer,
    MainContainer
} from '../../../styles/component.styles';

const client = new Client();

const InventoriesWrapper = ({ productId = null }) => {
    const [loading, setLoading] = useState(true);
    const [showDisplay, setShowDisplay] = useState(false);
    const [showUpdate, setShowUpdate] = useState(false);
    const [showRestock, setShowRestock] = useState(false);
    const [inventories, setInventories] = useState([]);
    const [inventory, setInventory] = useState({});

    useEffect(() => {
        ensureSocketConnected();

        const handleInventoryUpdate = async ({ id }) => {
            if (!id) return;
            try {
                const updated = await client.getInventoryById(id);
                setInventories(prev =>
                    prev.map(inv => (inv.id === id ? updated : inv))
                );
                setInventory(updated);
            } catch (err) {
                console.warn('Failed to update inventory in UI:', err);
            }
        };

        const offInventoryUpdate = onSafe('updateInventory', handleInventoryUpdate);
        return () => {
            offInventoryUpdate();
        };
    }, []);

    useEffect(() => {
        getInventories();
    }, []);

    const getInventories = async () => {
        setLoading(true);
        let res = [];
        if (productId !== null) {
            const product = await client.getProductById(productId);
            res = product.Inventories;
        } else {
            const getAllInventories = await client.getInventories();
            res = getAllInventories.rows;
        }
        setInventories(res);
        setLoading(false);
    };

    const handleRestock = async () => {
        await getInventories();
        selectCurrentInventory(inventory.id);
        setShowRestock(false);
    };

    const selectCurrentInventory = (id) => {
        const currentInventory = inventories.find(inv => inv.id === id);
        setInventory(currentInventory);
        setShowDisplay(true);
    };

    const display = () => {
        if (showUpdate) {
            return (
                <UpdateInventory
                    inventory={inventory}
                    onCancel={() => setShowUpdate(false)}
                    onUpdate={async () => {
                        await getInventories();
                        setShowUpdate(false);
                    }}
                />
            );
        }

        if (showRestock) {
            return (
                <InventoryRestock
                    inventory={inventory}
                    onSuccess={handleRestock}
                    onCancel={() => setShowRestock(false)}
                />
            );
        }

        return (
            <InventoryDisplay
                inventory={inventory}
                setShowUpdate={setShowUpdate}
                setShowRestock={setShowRestock}
            />
        );
    };

    return (
        <MainContainer>
            {loading ? (
                <Spinner />
            ) : (
                <ContentContainer>
                    <ComponentModal
                        isOpen={showDisplay}
                        onClose={() => setShowDisplay(false)}
                        title={`Inventory ${showUpdate ? '- Update' : showRestock ? '- Restock' : ''}`}
                    >
                        {display()}
                    </ComponentModal>

                    <InventoriesTable
                        inventories={inventories}
                        selectCurrentInventory={selectCurrentInventory}
                    />
                </ContentContainer>
            )}
        </MainContainer>
    );
};

export default InventoriesWrapper;